module.exports = __webpack_public_path__ + "static/media/icefields-12.5be1a8c3.jpg";